import React from 'react'

const ProductAttribute = (props) => {
    return (
        <div className="form-check" style={{display: 'none'}}>
            <label className="label_radio">
                <input
                    type="radio"
                    name={props.name}
                    className="form-check-input"
                    value={props.value}
                    checked={props.checked}
                    readOnly
                />
                {props.name}
            </label>
        </div>
    )
}

export default ProductAttribute;
